import { jsx as _jsx } from "react/jsx-runtime";
import { pluralReadableTypeName } from '@iotv/core-services';
import { edgeTypeMatrix } from '@iotv/datamodel';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
const debug = process.env.REACT_APP_DEBUG && false;
const nodeFilters = [
    { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Gateway' }] },
];
export const Gateways = ({ applicationData, user, transactionFunctions, lastKey }) => {
    const key = `${lastKey}_visible_Gateway`;
    const userGroups = user ? applicationData.getParentNodes(user).filter((n) => n.type === 'Group') : [];
    return (_jsx(TreeItem, { itemId: key, label: pluralReadableTypeName('Gateway'), children: applicationData !== undefined ? (_jsx(ObjectTree, { uniqueTreeId: key,
            nodeEdgeMapper: applicationData,
            contextObjects: userGroups,
            queryPaths: [
                {
                    stepQuery: {
                        objectTypeId: 'Group',
                        adjacencyType: AdjacentType.CHILD,
                        edgeTypeId: edgeTypeMatrix.Group.Group.group_allows_group.edgeTypeId,
                        nodeFilters,
                    },
                    renderTypeFolder: false,
                    nextSteps: getSingleTypeRecursivePath({ groupObjectType: 'Group', containedObjectType: 'Gateway' }),
                },
            ],
            transactionFunctions,
            hideTopStep: true }, key)) : (_jsx(NavigationSkeleton, {}, key)) }, key));
};
